async function errorText(res: Response, fallback: string): Promise<string> {
  try {
    const body: unknown = await res.json();
    const error = body && typeof body === 'object' ? (body as { error?: unknown }).error : null;
    if (typeof error === 'string' && error) return error;
    if (error && typeof error === 'object' && typeof (error as { message?: unknown }).message === 'string') {
      return (error as { message: string }).message;
    }
  } catch {
    // fall through
  }
  return fallback;
}

/** Starts viewing Pulse as this person, then reloads so every page shows their view. */
export async function startViewAs(userId: string): Promise<void> {
  const res = await fetch('/auth/view-as', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId }),
  });
  if (!res.ok) throw new Error(await errorText(res, 'Could not switch to their view.'));
  window.location.assign('/');
}

export async function stopViewAs(): Promise<void> {
  const res = await fetch('/auth/view-as', { method: 'DELETE' });
  if (!res.ok) throw new Error(await errorText(res, 'Could not go back to your view.'));
  window.location.assign('/');
}
